export enum PRODUCT_STATUS {
  COMMISSIONED = 'Commissioned',
  DECOMMISSIONED = 'Decommissioned',
}
